module.exports = __webpack_public_path__ + "static/media/land-geotiller.ae469135.svg";